
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Loi7S", function(module, exports) {

$parcel$export(module.exports, "createNotes", function () { return $08e73ba89a2710b5$export$a6281618eba5c8a8; });
$parcel$export(module.exports, "editNotes", function () { return $08e73ba89a2710b5$export$4f3d4ef8cc12870; });
$parcel$export(module.exports, "createTodos", function () { return $08e73ba89a2710b5$export$d73c8b8ba60e493f; });
$parcel$export(module.exports, "editTodos", function () { return $08e73ba89a2710b5$export$298a394e1066cd97; });
$parcel$export(module.exports, "createScrumBoard", function () { return $08e73ba89a2710b5$export$fdfb1371bb41f6ab; });
$parcel$export(module.exports, "createNewList", function () { return $08e73ba89a2710b5$export$6819fc501dde6d24; });
$parcel$export(module.exports, "createEvent", function () { return $08e73ba89a2710b5$export$c30017717ce2168e; });
var $08e73ba89a2710b5$export$846d0d105943fb86 = {
    notes: []
};
var $08e73ba89a2710b5$export$bd1c7d1f0790489f = {
    scrumboard: [],
    todo: [],
    settings: {}
};
var $08e73ba89a2710b5$var$generateShortId = function generateShortId(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var result = "";
    for(var i = 0; i < length; i++){
        var randomIndex = Math.floor(Math.random() * chars.length);
        result += chars.charAt(randomIndex);
    }
    return result;
};
var $08e73ba89a2710b5$export$a6281618eba5c8a8 = function createNotes() {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: 0
    };
    $08e73ba89a2710b5$export$846d0d105943fb86.notes.push(data);
    return data;
};
var $08e73ba89a2710b5$export$4f3d4ef8cc12870 = function editNotes(noteId, favorited) {
    var today = new Date().toISOString();
    var noteTitle = document.getElementById("n-title").value;
    var noteDescription = document.getElementById("n-description").value;
    var noteTag = document.getElementById("n-tags").value;
    var data = {
        id: noteId,
        title: noteTitle,
        description: noteDescription,
        tag: noteTag,
        date: today,
        favorited: favorited
    };
    return data;
};
var $08e73ba89a2710b5$export$d73c8b8ba60e493f = function createTodos(quill) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: shortId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: 0,
        completed: 0,
        trash: 0,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$298a394e1066cd97 = function editTodos(quill, options) {
    var today = new Date().toISOString();
    var todoTitle = document.getElementById("task-text").value;
    // const todoDescription = quill.getText().trim();
    var todoDescription = quill.root.innerHTML;
    var todoPriority = document.getElementById("priority").value;
    var data = {
        id: options.todoId,
        title: todoTitle,
        description: todoDescription,
        priority: todoPriority,
        important: options.important,
        completed: options.completed,
        trash: options.trash,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$fdfb1371bb41f6ab = function createScrumBoard(options) {
    var isEdit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth());
    var yyyy = today.getFullYear();
    // prettier-ignore
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    today = dd + " " + monthNames[mm] + ", " + yyyy;
    var taskTitle = document.getElementById("s-task").value;
    var taskText = document.getElementById("s-text").value;
    var progress = document.getElementById("s-progress").value;
    var shortId = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? options.id : shortId,
        title: taskTitle,
        description: taskText,
        tasksection: options.tasksection,
        order: options.order,
        progress: progress,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$6819fc501dde6d24 = function createNewList() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, order = arguments.length > 2 ? arguments[2] : void 0;
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    today = "".concat(mm, ".").concat(dd, ".").concat(yyyy);
    var listId = $08e73ba89a2710b5$var$generateShortId(5);
    var listTitle = document.getElementById("s-list-name").value;
    var listTitleLower = listTitle.toLowerCase();
    var listTitleRemoveWhiteSpaces = listTitleLower.split(" ").join("_");
    var listSectionDataAttr = "s-".concat(listTitleRemoveWhiteSpaces, "-").concat(listId);
    var data = {
        id: isEdit ? options.section : listSectionDataAttr,
        title: listTitle,
        order: isEdit ? options.order : order,
        date: today
    };
    return data;
};
var $08e73ba89a2710b5$export$c30017717ce2168e = function createEvent() {
    var isEdit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, OldEventId = arguments.length > 1 ? arguments[1] : void 0;
    var getModalCheckedRadioBtnEl = document.querySelector('input[name="event-level"]:checked');
    var getTitleValue = document.querySelector("#event-title").value;
    var setModalStartDateValue = document.querySelector("#event-start-date").value;
    var setModalEndDateValue = document.querySelector("#event-end-date").value;
    var setModalUrlValue = document.querySelector("#event-url").value;
    var getModalCheckedRadioBtnValue = getModalCheckedRadioBtnEl !== null ? getModalCheckedRadioBtnEl.value : "";
    var eventID = $08e73ba89a2710b5$var$generateShortId(5);
    var data = {
        id: isEdit ? OldEventId : eventID,
        title: getTitleValue,
        start: setModalStartDateValue,
        end: setModalEndDateValue,
        url: setModalUrlValue,
        allDay: false,
        extendedProps: {
            calendar: getModalCheckedRadioBtnValue
        }
    };
    return data;
};

});

parcelRegister("ev0Km", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e48a38ea1e4026$export$2e2bcd8739ae039; });

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $2B8he = parcelRequire("2B8he");
var $a8e48a38ea1e4026$var$previewView = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(previewView, appView);
    var _super = (0, $jhb1H._)(previewView);
    function previewView() {
        (0, $5kWiG._)(this, previewView);
        return _super.apply(this, arguments);
    }
    (0, $hHaEF._)(previewView, [
        {
            key: "notesMarkup",
            value: function notesMarkup(data, options) {
                return '\n          <div class="note-item all-notes '.concat(data.tag, " ").concat(options.favorite, '" data-id="').concat(data.id, '" data-favorited="').concat(data.favorited, '">\n            <div class="note-inner-content">\n              <div class="note-content">\n                <p class="note-title" data-noteTitle="').concat(data.title, '">\n                  ').concat(options.limitTitle, '\n                </p>\n                <p class="meta-time">\n                 ').concat(options.edited, " ").concat(options.newDate, '\n                </p>\n                <div class="note-description-content">\n                  <p class="note-description" data-noteDescription="').concat(data.description, '">\n                    ').concat(options.limitDescription, '\n                  </p>\n                </div>\n              </div>\n              <div class="note-action">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star fav-note">\n                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 delete-note">\n                  <polyline points="3 6 5 6 21 6"></polyline>\n                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                  <line x1="10" y1="11" x2="10" y2="17"></line>\n                  <line x1="14" y1="11" x2="14" y2="17"></line>\n                </svg>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 edit-note"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg>\n              </div>\n              <div class="note-footer">\n                <div class="tags-selector btn-group">\n                  <a class="nav-link dropdown-toggle d-icon label-group" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">\n                    <span>\n                      <div class="tags">\n                        <div class="g-dot-personal"></div>\n                        <div class="g-dot-work"></div>\n                        <div class="g-dot-social"></div>\n                        <div class="g-dot-important"></div>\n                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                          <circle cx="12" cy="12" r="1"></circle>\n                          <circle cx="12" cy="5" r="1"></circle>\n                          <circle cx="12" cy="19" r="1"></circle>\n                        </svg>\n                      </div>\n                    </span>\n                  </a>\n                  <div class="dropdown-menu dropdown-menu-right d-icon-menu">\n                    <a class="note-personal label-group-item label-personal dropdown-item position-relative g-dot-personal" href="javascript:void(0);"> Personal</a>\n                    <a class="note-work label-group-item label-work dropdown-item position-relative g-dot-work" href="javascript:void(0);"> Work</a>\n                    <a class="note-social label-group-item label-social dropdown-item position-relative g-dot-social" href="javascript:void(0);"> Social</a>\n                    <a class="note-important label-group-item label-important dropdown-item position-relative g-dot-important" href="javascript:void(0);"> Important</a>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        ');
            }
        },
        {
            key: "todoMarkup",
            value: function todoMarkup(data, options) {
                return '\n      <div class="todo-item '.concat(data.trash ? "" : "all-list", " ").concat(options.important, " ").concat(options.completed, " ").concat(options.trash, '" data-id="').concat(data.id, '" data-completed="').concat(data.completed, '" data-trash="').concat(data.trash, '"\n      data-important="').concat(data.important, '" data-priority="').concat(data.priority, '">\n        <div class="todo-item-inner">\n          <div class="n-chk text-center">\n            <div class="form-check form-check-primary form-check-inline mt-1 me-0" data-bs-toggle="collapse" data-bs-target="">\n              <input class="form-check-input inbox-chkbox" type="checkbox" ').concat(data.completed ? "checked" : "", '>\n            </div>\n          </div>\n\n          <div class="todo-content">\n            <h5 class="todo-heading" data-todoheading="').concat(data.title, '">\n             ').concat(options.limitTitle, '\n            </h5>\n            <p class="todo-text" data-todohtml="').concat(data.description, '" data-todotext="').concat(data.description, '">\n              ').concat(data.description, '\n            </p>\n          </div>\n\n          <div class="meta-frame">\n            <p class="meta-time todo-time">').concat(options.isCompleted, " ").concat(options.edited, " ").concat(options.newDate, '</p>\n          </div>\n\n          <div class="priority-dropdown custom-dropdown-icon">\n            <div class="dropdown p-dropdown">\n              <a class="dropdown-toggle ').concat(data.priority, '" href="#" role="button" id="dropdownMenuLink-1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                  <line x1="12" y1="8" x2="12" y2="12"></line>\n                  <line x1="12" y1="16" x2="12" y2="16"></line>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-1">\n                <a class="danger dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  High</a>\n                <a class="warning dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Middle</a>\n                <a class="primary dropdown-item p-label-group" href="javascript:void(0);"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon">\n                    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>\n                    <line x1="12" y1="8" x2="12" y2="12"></line>\n                    <line x1="12" y1="16" x2="12" y2="16"></line>\n                  </svg>\n                  Low</a>\n              </div>\n            </div>\n          </div>\n\n          <div class="action-dropdown custom-dropdown-icon">\n            <div class="dropdown">\n              <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-2" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-vertical">\n                  <circle cx="12" cy="12" r="1"></circle>\n                  <circle cx="12" cy="5" r="1"></circle>\n                  <circle cx="12" cy="19" r="1"></circle>\n                </svg>\n              </a>\n\n              <div class="dropdown-menu left" aria-labelledby="dropdownMenuLink-2">\n                <a class="edit dropdown-item" href="javascript:void(0);">Edit</a>\n                <a class="important dropdown-item" href="javascript:void(0);">').concat(data.important === 1 ? "Mark as Normal" : "Mark as Important", '</a>\n                <a class="dropdown-item delete" href="javascript:void(0);">Delete</a>\n                <a class="dropdown-item permanent-delete" href="javascript:void(0);">Permanent Delete</a>\n                <a class="dropdown-item revive" href="javascript:void(0);">Revive Task</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    ');
            }
        },
        {
            key: "scrumBoardMarkup",
            value: function scrumBoardMarkup(data) {
                return '\n        <div data-draggable="true" data-list-id="'.concat(data.tasksection, '" data-card-id="').concat(data.id, '" data-order="').concat(data.order, '" class="card task-text-progress" style="">\n          <div class="card-body">\n            <div class="task-header">\n              <div>\n                <h4 class="" data-taskTitle="').concat(data.title, '">').concat(data.title, '</h4>\n              </div>\n              <div>\n                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 s-task-edit">\n                  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>\n                </svg>\n              </div>\n            </div>\n            <div class="task-body">\n              <div class="task-content">\n                <p class="" data-taskText="').concat(data.description, '">').concat(data.description, '</p>\n                <div class="').concat(data.progress ? "" : "progress-none-bar d-none", '">\n                    <div class="progress br-30">\n                      <div class="progress-bar bg-success" role="progressbar" data-progressstate="').concat(data.progress, '" style="width: ').concat(data.progress, '%" aria-valuenow="').concat(data.progress, '" aria-valuemin="0" aria-valuemax="100">\n                      </div>\n                    </div>\n                    <p class="progress-count">').concat(data.progress, '%</p>\n                </div>\n              </div>\n              <div class="task-bottom">\n                <div class="tb-section-1">\n                  <span data-taskDate="').concat(data.date, '">\n                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">\n                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>\n                      <line x1="16" y1="2" x2="16" y2="6"></line>\n                      <line x1="8" y1="2" x2="8" y2="6"></line>\n                      <line x1="3" y1="10" x2="21" y2="10"></line>\n                    </svg>\n                    ').concat(data.date, '\n                  </span>\n                </div>\n                <div class="tb-section-2">\n                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2 s-task-delete">\n                    <polyline points="3 6 5 6 21 6"></polyline>\n                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>\n                    <line x1="10" y1="11" x2="10" y2="17"></line>\n                    <line x1="14" y1="11" x2="14" y2="17"></line>\n                  </svg>\n                </div>\n              </div>\n            </div>\n          </div>');
            }
        },
        {
            key: "scrumListMarkup",
            value: function scrumListMarkup(data) {
                return '\n    <div data-section="'.concat(data.id, '" data-order="').concat(data.order, '" class="task-list-container mb-4 " data-connect="sorting">\n      <div class="connect-sorting">\n        <div class="task-container-header">\n          <h6 class="s-heading" data-listTitle="').concat(data.title, '">\n            ').concat(data.title, '\n          </h6>\n          <div class="dropdown">\n            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink-4" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">\n                <circle cx="12" cy="12" r="1"></circle>\n                <circle cx="19" cy="12" r="1"></circle>\n                <circle cx="5" cy="12" r="1"></circle>\n              </svg>\n            </a>\n            <div class="dropdown-menu dropdown-menu-right left" aria-labelledby="dropdownMenuLink-4">\n              <a class="dropdown-item list-edit" href="javascript:void(0);">Edit List</a>\n              <a class="dropdown-item list-delete" href="javascript:void(0);">Delete List</a>\n              <a class="dropdown-item list-clear-all" href="javascript:void(0);">Clear All Cards</a>\n            </div>\n          </div>\n        </div>\n        <div class="connect-sorting-content" data-sortable="true">\n        </div>\n        <div class="add-s-task">\n          <a class="addTask">\n            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle">\n              <circle cx="12" cy="12" r="10"></circle>\n              <line x1="12" y1="8" x2="12" y2="16"></line>\n              <line x1="8" y1="12" x2="16" y2="12"></line>\n            </svg>\n            Add Task\n          </a>\n        </div>\n      </div>\n    </div>\n  ');
            }
        },
        {
            key: "timeLineMarkup",
            value: function timeLineMarkup(data, timeFormat) {
                return '\n          <div class="item-timeline">\n            <p class="t-time">'.concat(timeFormat.timeDigits, '</p>\n            <div class="t-dot t-dot-').concat(data.tag, '"></div>\n            <div class="t-text">\n              <p>').concat(data.title, '</p>\n              <p class="t-meta-time">').concat(timeFormat.timeAgo, "</p>\n              ").concat(data.startdate ? '<p class="t-meta-time event-time"> '.concat(data.startdate, "</p>") : "", "\n            </div>\n          </div>\n    ");
            }
        }
    ]);
    return previewView;
}((0, $2B8he.default));
var $a8e48a38ea1e4026$export$2e2bcd8739ae039 = new $a8e48a38ea1e4026$var$previewView();

});


var $1K4o4 = parcelRequire("1K4o4");

var $e2996 = parcelRequire("e2996");

var $5kWiG = parcelRequire("5kWiG");

var $hHaEF = parcelRequire("hHaEF");

var $8EGc6 = parcelRequire("8EGc6");

var $dACZV = parcelRequire("dACZV");

var $jhb1H = parcelRequire("jhb1H");

var $gAasq = parcelRequire("gAasq");

var $Loi7S = parcelRequire("Loi7S");

var $2B8he = parcelRequire("2B8he");

var $gpGF7 = parcelRequire("gpGF7");

var $ev0Km = parcelRequire("ev0Km");

var $4HRPq = parcelRequire("4HRPq");
var $4eaa658d98a99020$var$Notes = /*#__PURE__*/ function(appView) {
    "use strict";
    (0, $dACZV._)(Notes, appView);
    var _super = (0, $jhb1H._)(Notes);
    function Notes() {
        (0, $5kWiG._)(this, Notes);
        var _this;
        _this = _super.call(this);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_parentElement", document.querySelector(".note-inbox"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_listBtns", document.querySelectorAll(".list-actions"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_addNoteBtn", document.querySelector("#btn-n-add"));
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_containterItem", ".note-item");
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_message", "Note was deleted successfully");
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_errorMsg", "Empty Notes, Add a new Note!");
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_titleMaxLength", 100);
        (0, $8EGc6._)((0, $1K4o4._)(_this), "_descriptionMaxLength", 500);
        _this.isEdit = false;
        _this.noteId = null;
        _this.favorited = null;
        _this.newMarkup = true;
        _this.initialize();
        return _this;
    }
    (0, $hHaEF._)(Notes, [
        {
            key: "initialize",
            value: function initialize() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._setupEventListeners()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_setupEventListeners",
            value: function _setupEventListeners() {
                var _this = this;
                return (0, $e2996._)(function() {
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getAllItems()
                                ];
                            case 1:
                                _state.sent();
                                _this._mobileMenu();
                                _this.toggleMenuViews();
                                _this._addNewNote();
                                _this._handlerAddButton();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_deleteNote",
            value: function _deleteNote() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var deleteBtns, self1;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        try {
                            deleteBtns = document.querySelectorAll(".delete-note");
                            self1 = _this;
                            deleteBtns.forEach(function(del) {
                                del.addEventListener("click", function(e) {
                                    e.preventDefault();
                                    self1.openModal("#noteDelete");
                                    $(".delete-note").on("click", function() {
                                        self1.handleNoteDeletion(e);
                                    });
                                });
                            });
                        } catch (err) {
                            _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "handleNoteDeletion",
            value: function handleNoteDeletion(e) {
                var _this = this;
                return (0, $e2996._)(function() {
                    var note, dataId, request, err, storeLength;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                note = e.target.closest(".note-item");
                                dataId = note.getAttribute("data-id");
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    6
                                ]);
                                return [
                                    4,
                                    $gpGF7.deleteItemFromDatabase(dataId, "notes")
                                ];
                            case 2:
                                request = _state.sent();
                                if (request) {
                                    note.remove();
                                    _this.closeModal("#noteDelete", _this._message, true);
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    $gpGF7.getObjectStoreLength("notes")
                                ];
                            case 5:
                                storeLength = _state.sent();
                                if (storeLength === 0) _this.renderErrorMessage();
                                $("#noteDelete").modal("hide");
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_showNoteModal",
            value: function _showNoteModal() {
                var notes = document.querySelectorAll(".note-content");
                var self1 = this;
                notes.forEach(function(note) {
                    note.addEventListener("click", function(e) {
                        e.preventDefault();
                        var closestNoteContent = e.target.closest(".note-content");
                        if (!closestNoteContent) return;
                        var titleElement = closestNoteContent.querySelector(".note-title");
                        var descriptionElement = closestNoteContent.querySelector(".note-description");
                        var title = titleElement.getAttribute("data-notetitle");
                        var description = descriptionElement.getAttribute("data-notedescription");
                        self1.showContentModal(title, description, "#NoteShowListItem");
                    });
                });
            }
        },
        {
            key: "_favoriteNote",
            value: function _favoriteNote() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var favBtns, self1;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        favBtns = document.querySelectorAll(".fav-note");
                        self1 = _this;
                        favBtns.forEach(function(fav) {
                            fav.addEventListener("click", function() {
                                var _ref = (0, $e2996._)(function(e) {
                                    return (0, $gAasq.__generator)(this, function(_state) {
                                        e.preventDefault();
                                        try {
                                            self1.favoriteNote(e);
                                        } catch (err) {
                                            self1.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "favoriteNote",
            value: function favoriteNote(e) {
                var _this = this;
                return (0, $e2996._)(function() {
                    var note, noteID, favId, favoriteNote, err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                note = e.target.closest(".note-item");
                                noteID = note.getAttribute("data-id");
                                favId = note.getAttribute("data-favorited");
                                if (!note) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $gpGF7.updateItemInDatabase(noteID, "notes", {
                                        favorited: +favId === 0 ? 1 : 0
                                    })
                                ];
                            case 1:
                                favoriteNote = _state.sent();
                                if (favoriteNote) {
                                    favId === "1" ? note.classList.remove("note-fav") : note.classList.add("note-fav");
                                    favId === "1" ? note.setAttribute("data-favorited", "0") : note.setAttribute("data-favorited", "1");
                                    _this.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_addLabelGroups",
            value: function _addLabelGroups() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var tagsSelect;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        tagsSelect = document.querySelectorAll(".tags-selector .label-group-item");
                        tagsSelect.forEach(function(tag) {
                            tag.addEventListener("click", (function() {
                                var _ref = (0, $e2996._)(function(e) {
                                    var parentNoteItem, getClass, getSplitclass, newTag, noteID, newData, error;
                                    return (0, $gAasq.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                e.preventDefault();
                                                parentNoteItem = e.target.closest(".note-item");
                                                getClass = tag.className;
                                                getSplitclass = getClass.split(" ")[0];
                                                if (tag.classList.contains("label-personal")) {
                                                    parentNoteItem.classList.remove("note-social", "note-work", "note-important");
                                                    parentNoteItem.classList.toggle(getSplitclass);
                                                } else if (tag.classList.contains("label-work")) {
                                                    parentNoteItem.classList.remove("note-personal", "note-social", "note-important");
                                                    parentNoteItem.classList.toggle(getSplitclass);
                                                } else if (tag.classList.contains("label-social")) {
                                                    parentNoteItem.classList.remove("note-personal", "note-work", "note-important");
                                                    parentNoteItem.classList.toggle(getSplitclass);
                                                } else if (tag.classList.contains("label-important")) {
                                                    parentNoteItem.classList.remove("note-personal", "note-social", "note-work");
                                                    parentNoteItem.classList.toggle(getSplitclass);
                                                }
                                                newTag = parentNoteItem.classList.contains(getSplitclass);
                                                noteID = parentNoteItem.getAttribute("data-id");
                                                newData = {
                                                    tag: newTag ? getSplitclass : ""
                                                };
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    $gpGF7.updateItemInDatabase(noteID, "notes", newData)
                                                ];
                                            case 2:
                                                _state.sent();
                                                this.successMessageInfo((0, $4HRPq.SUCCESSUPDATE));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                error = _state.sent();
                                                this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            })().bind(_this));
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_mobileMenu",
            value: function _mobileMenu() {
                var _this = this;
                var hamburger = document.querySelector(".hamburger");
                var appNoteOverlay = document.querySelector(".app-note-overlay");
                var tabLinks = document.querySelectorAll(".tab-title .nav-pills a.nav-link");
                var tabTitle = document.querySelector(".tab-title");
                if (hamburger) hamburger.addEventListener("click", (function() {
                    tabTitle.classList.toggle("note-menu-show");
                    appNoteOverlay.classList.toggle("app-note-overlay-show");
                }).bind(this));
                if (appNoteOverlay) appNoteOverlay.addEventListener("click", (function(e) {
                    tabTitle.classList.remove("note-menu-show");
                    appNoteOverlay.classList.remove("app-note-overlay-show");
                }).bind(this));
                if (tabLinks) tabLinks.forEach(function(link) {
                    link.addEventListener("click", (function(e) {
                        tabTitle.classList.remove("note-menu-show");
                        if (appNoteOverlay) appNoteOverlay.classList.remove("app-note-overlay-show");
                    }).bind(_this));
                });
            }
        },
        {
            key: "_handlerAddButton",
            value: function _handlerAddButton() {
                var addBtn = document.querySelector("#btn-add-notes");
                if (addBtn) {
                    var self1 = this;
                    addBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        self1._addNoteBtn.textContent = self1.isEdit ? "Save" : "Add";
                        var title = document.querySelector("#n-title");
                        var description = document.querySelector("#n-description");
                        self1.openNoteModal("#notesMailModal", title, description);
                    });
                }
            }
        },
        {
            key: "setEditStateAndNoteId",
            value: function setEditStateAndNoteId(noteId, favorited) {
                this.isEdit = true;
                this.noteId = noteId;
                this.favorited = +favorited;
                this.newMarkup = false;
            }
        },
        {
            key: "resetEditStateAndNoteId",
            value: function resetEditStateAndNoteId() {
                this.isEdit = false;
                this.noteId = null;
                this.favorited = null;
                this.newMarkup = true;
            }
        },
        {
            key: "_isEdit",
            value: function _isEdit() {
                var editBtns = document.querySelectorAll(".edit-note");
                var self1 = this;
                editBtns.forEach(function(editbtn) {
                    editbtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var noteId = e.target.closest(".note-item").getAttribute("data-id");
                        var favorited = e.target.closest(".note-item").getAttribute("data-favorited");
                        self1.setEditStateAndNoteId(noteId, favorited);
                        self1._addNoteBtn.textContent = self1.isEdit ? "Save" : "Add";
                        self1.populateModalEdit(e);
                        self1._hideModalInfo();
                    });
                });
            }
        },
        {
            key: "populateModalEdit",
            value: function populateModalEdit(e) {
                var note = e.target.closest(".note-item");
                var noteTitle = note.querySelector(".note-title").getAttribute("data-notetitle");
                var noteDescription = note.querySelector(".note-description").getAttribute("data-notedescription");
                var title = document.querySelector("#n-title");
                title.value = noteTitle;
                var description = document.querySelector("#n-description");
                description.value = noteDescription;
                this.openNoteModal("#notesMailModal", title, description);
            }
        },
        {
            key: "_addNewNote",
            value: function _addNewNote() {
                if (this._addNoteBtn) {
                    var self1 = this;
                    this._addNoteBtn.addEventListener("click", (function() {
                        var _ref = (0, $e2996._)(function(e) {
                            var data, _tmp, err;
                            return (0, $gAasq.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        if (!this._validateNoteInput()) return [
                                            2
                                        ];
                                        data = self1.isEdit ? $Loi7S.editNotes(self1.noteId, self1.favorited) : $Loi7S.createNotes();
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            7,
                                            8,
                                            9
                                        ]);
                                        if (!self1.isEdit) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            $gpGF7.updateItemInDatabase(self1.noteId, "notes", data)
                                        ];
                                    case 2:
                                        _tmp = _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            $gpGF7.addItemtoDatabase(data, "notes")
                                        ];
                                    case 4:
                                        _tmp = _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        _tmp;
                                        return [
                                            4,
                                            this.displayNotes(data, true)
                                        ];
                                    case 6:
                                        _state.sent();
                                        self1.successMessageInfo((0, $4HRPq.NOTESUCESS));
                                        return [
                                            3,
                                            9
                                        ];
                                    case 7:
                                        err = _state.sent();
                                        self1.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                        return [
                                            3,
                                            9
                                        ];
                                    case 8:
                                        $("#notesMailModal").modal("hide");
                                        this._hideModalInfo();
                                        return [
                                            7
                                        ];
                                    case 9:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    })().bind(this));
                }
            }
        },
        {
            key: "displayNotes",
            value: function displayNotes(data) {
                var newNote = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $e2996._)(function() {
                    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, note, err, err1;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    10,
                                    ,
                                    11
                                ]);
                                if (!data || Array.isArray(data) && data.length === 0) return [
                                    2,
                                    _this.renderErrorMessage()
                                ];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!newNote) return [
                                    3,
                                    1
                                ];
                                _this.removeEmptyContainer();
                                _this.render(data);
                                return [
                                    3,
                                    9
                                ];
                            case 1:
                                if (!(!newNote && !!_this._parentElement)) return [
                                    3,
                                    9
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = data[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                note = _step.value;
                                return [
                                    4,
                                    _this.render(note)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                        _iterator["return"]();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                err1 = _state.sent();
                                self.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    11
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAllItems",
            value: function getAllItems() {
                var _this = this;
                return (0, $e2996._)(function() {
                    var data, sortedItems, err;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    $gpGF7.getAllItemsFromDatabase("notes")
                                ];
                            case 1:
                                data = _state.sent();
                                sortedItems = _this.sortDataByTimestamp(data);
                                return [
                                    4,
                                    _this.displayNotes(sortedItems)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                err = _state.sent();
                                _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup(data, dataNew) {
                var newDate = this.formatDate(data.date, dataNew);
                var favorite = data.favorited === 1 ? "note-fav" : "";
                var limitTitle = this.limitCharacters(data.title, (0, $4HRPq.NOTE_TITLE_LIMIT));
                var limitDescription = this.limitCharacters(data.description, (0, $4HRPq.NOTE_DESCRIPTION_LIMIT));
                var edited = data.isEdited ? "Edited:" : "";
                var markup = (0, $ev0Km.default).notesMarkup(data, {
                    newDate: newDate,
                    favorite: favorite,
                    limitTitle: limitTitle,
                    limitDescription: limitDescription,
                    edited: edited
                });
                return markup;
            }
        },
        {
            key: "render",
            value: function render(data) {
                var dataNew = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var _this = this;
                return (0, $e2996._)(function() {
                    var containerElement, markup, element;
                    return (0, $gAasq.__generator)(this, function(_state) {
                        try {
                            containerElement = _this._parentElement.querySelector('.note-item[data-id="'.concat(data.id, '"]'));
                            markup = _this._generateMarkup(data, dataNew);
                            if (!_this.newMarkup) {
                                _this.update(data, markup, containerElement);
                                _this._renderFunctions();
                                return [
                                    2
                                ];
                            }
                            // $('#ct').prepend(markup);
                            // const parentEl = document.querySelector('.note-inbox');
                            element = _this._parentElement.querySelector(".note-container");
                            element.insertAdjacentHTML("afterbegin", markup);
                            _this._renderFunctions();
                        } catch (err) {
                            _this.failedMessageInfo((0, $4HRPq.FAILEDMESSAGE));
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_renderFunctions",
            value: function _renderFunctions() {
                this._deleteNote();
                this._favoriteNote();
                this._showNoteModal();
                this._isEdit();
                this._addLabelGroups();
                var noteEl = document.querySelectorAll(".note-item");
                this._searchLists(noteEl);
            }
        },
        {
            key: "_hideModalInfo",
            value: function _hideModalInfo() {
                var modal = document.getElementById("notesMailModal");
                var self1 = this;
                if (modal) $(modal).on("hidden.bs.modal", function(event) {
                    event.preventDefault();
                    document.getElementById("n-title").value = "";
                    document.getElementById("n-description").value = "";
                    document.getElementById("n-tags").value = "";
                    self1.resetEditStateAndNoteId();
                });
            }
        },
        {
            key: "_validateNoteInput",
            value: function _validateNoteInput() {
                var getValidationField = document.getElementsByClassName("validation-text");
                var getNoteTitleInput = document.getElementById("n-title");
                var getNoteDescriptionInput = document.getElementById("n-description");
                var result = this.validateInput(getValidationField, getNoteTitleInput, getNoteDescriptionInput);
                return result;
            }
        }
    ]);
    return Notes;
}((0, $2B8he.default));
new $4eaa658d98a99020$var$Notes();


//# sourceMappingURL=notes.a8924b61.js.map
